import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import Collapsible from 'react-collapsible';
import LikeIcon from '../../../assets/Feed/LikeIcon';
import ChatIcon from '../../../assets/Posts/ChatIcon';
import EmoteIcon from '../../../assets/Posts/EmoteIcon';
import ShareIcon from '../../../assets/Posts/ShareIcon';
import SmallArrowDown from '../../../assets/Posts/SmallArrowDown';
import { api } from '../../../services/api';
import { CommentsResponse } from '../../../services/apiTypes';
import { numberFormatter } from '../../../utils/formatter';
import DeleteModal from '../../Modals/DeleteModal';
import PostOptionsModal from '../../Modals/PostOptionsModal';
import SharePostModal from '../../Modals/SharePostModal';
import User from '../../User';
import Comment from '../Comment';
import {
  CommentPlaceholder,
  CommentSection,
  CommentsContainer,
  Container,
  Description,
  DescriptionSection,
  ExpandArrow,
  ExpandContainer,
  ExpandContainerBottom,
  ExpandContainerTop,
  ExpandIconContainer,
  FollowText,
  HideTagsContainer,
  HorizontalIconsContainer,
  Icon,
  IconsDupla,
  InnerBottomContainer,
  InnerTopContainer,
  MasterContainer,
  ShowMore,
  Tag,
  TranslateContainer
} from './styles';

type PostInformationProps = {
  publicationId: string;
  selectedImage: number;
  authorUsername: string;
  authorAvatarUrl: string;
  timeSince: string;
  descriptions: string[];
  feedType: string;
  tags: string[];
  likes: number;
  comments: number;
  liked: boolean;
  setLiked: (liked: boolean) => void;
  likesCount: number;
  setLikesCount: (likes: number) => void;
  commentsCount: number;
  setCommentsCount: (comments: number) => void;
};

export default function SnipzInformation({
  publicationId,
  selectedImage,
  authorUsername,
  authorAvatarUrl,
  timeSince,
  descriptions,
  tags,
  liked,
  setLiked,
  likesCount,
  setLikesCount,
  commentsCount,
  setCommentsCount,
  feedType
}: PostInformationProps) {
  const [shortDescription, setShortDescription] = useState(descriptions[selectedImage].slice(0, 97));
  const [showMore, setShowMore] = useState(true);
  const [showTags, setShowTags] = useState(false);
  const [tagsString, setTagsString] = useState('');
  const [showComments, setShowComments] = useState<boolean>(true);
  const [commmentValue, setCommentValue] = useState<string>('');
  const [commentsInfos, setCommentsInfos] = useState<CommentsResponse[]>([]);
  const [answerTarget, setAnswerTarget] = useState<string>('');
  const [reloadComments, setReloadComments] = useState<boolean>(false);
  const [postModal, setPostModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [reloadSubComments, setReloadSubComments] = useState<boolean>(true);
  const [commentModalOpen, setCommentModalOpen] = useState<boolean>(false);
  const [commentModalId, setCommentModalId] = useState<string>("");
  const [scrollOverflow, setScrollOverflow] = useState<boolean>(false);

  const [commentInputFocus, setCommentInputFocus] = useState<boolean>(false);
  const handleKeyDown = async (e: any) => {
    if (e.key === 'Enter') {
      const payload = {
        publicationId: publicationId,
        parentId: answerTarget !== '' ? answerTarget : publicationId,
        content: commmentValue
      }
      try {
        const res = await api.post(`/comments/create`, payload);
        if (res.status === 200) {
          setTimeout(() => {
            setReloadComments(!reloadComments)
            setReloadSubComments(true)
          }, 1000)
        }
      } catch (error) {
        console.error(error);
      }
      setCommentValue('');
      setAnswerTarget('');
      setCommentsCount(commentsCount + 1);
    }
  }

  const handleComment = (value: string) => {
    setCommentValue(value)
    if (value === '') {
      setAnswerTarget('')
    }
  }

  useEffect(() => {
    if (tags && tags.length > 0) {
      let newTag = '';
      tags.forEach((tag) => {
        newTag += `#${tag} `;
      }
      );
      setTagsString(newTag);
    }
  }, [tags]);

  useEffect(() => {
    if (showMore && descriptions && descriptions.length > 0) {
      setShortDescription(descriptions[selectedImage]);
    }
    else {
      if (descriptions && descriptions[selectedImage] && descriptions[selectedImage].length > 0) {
        setShortDescription(descriptions[selectedImage].slice(0, 97));
      } else {
        setShortDescription(' ')
      }
    }
  }, [showMore, selectedImage]);

  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (commentsCount !== 0 || reloadComments) {
      api.get(`/comments/${publicationId}`).then(response => {
        setCommentsInfos(response.data);
        // console.log('comments', response.data)
      }
      );
    }
    setReloadComments(false);
  }, [reloadComments]);

  useEffect(() => {
    if (reloadComments) {
      api.get(`/comments/${publicationId}`).then(response => {
        setCommentsInfos(response.data);
        // console.log('comments', response.data)
      }
      );
    }
    setReloadComments(false);
  }, [reloadComments]);

  const handleLike = async () => {
    setLiked(!liked);
    if (!liked) {
      setLikesCount(likesCount + 1)
    } else {
      setLikesCount(likesCount - 1)
    }
    try {
      const response = await api.post(`/like/${publicationId}`)
      if (response.status !== 200 && !liked) {
        setLiked(!liked)
        setLikesCount(likesCount - 1)
      }
    } catch (error) {
      console.log(error)
    }
  }


  const handleModalActions = async (action: string) => {
    if (action === 'post') {
      setPostModal(!postModal);
    } else if (action === 'share') {
      setShareModal(!shareModal);
    } else if (action === 'delete') {
      setPostModal(false);
      setDeleteModal(!deleteModal);
    } else if (action === 'confirmDelete') {
      try {
        const response = await api.delete(`/media/publication/${publicationId}`)
        if (response.status === 200) {
          setReloadComments(!reloadComments)
        }
      } catch (error) {
        console.log(error)
      }
      setDeleteModal(!deleteModal);
    } else if (action === 'noDelete') {
      setDeleteModal(!deleteModal);
    }
  }

  const handleExpandComments = () => {
    setShowComments(!showComments);
  }

  const handleExpandTags = () => {
    setShowTags(!showTags);
  }

  const scrollRef = useRef<any>(null);
  const [scrollPosition, setScrollPosition] = useState<number>(20);

  useEffect(() => {
    if (scrollRef.current) {
      const scrollY = scrollRef?.current?.scrollTop;
      setScrollPosition(scrollY);
    }
  }, [scrollRef]);


  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(scrollRef.current.scrollTop);
    };

    const ref = scrollRef.current;
    if (ref) {
      ref.addEventListener('scroll', handleScroll);
    }

    // Cleanup event listener on component unmount
    return () => {
      if (ref) {
        ref.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    if (commentModalOpen) {
      setScrollOverflow(false);
    } else {
      setScrollOverflow(true);
    }
  }, [commentModalOpen]);

  return (
    <MasterContainer>
      <AnimatePresence initial={false}>
        {open && (
          // <motion.div
          //   variants={{
          //     open: { opacity: 1, width: "100%" },
          //     collapsed: { opacity: 0, width: 0 }
          //   }}
          //   key="content"
          //   initial="collapsed"
          //   animate="open"
          //   exit="collapsed"
          //   transition={{ duration: 0.7, ease: [0.04, 0.62, 0.23, 0.98] }}
          // >
          <Container>
            <InnerTopContainer>
              <User icon={authorAvatarUrl} username={authorUsername} timeSince={timeSince} follow={true} options={true} publicationId={publicationId} />
              <DescriptionSection>
                <Description>
                  {shortDescription}
                  {descriptions[selectedImage].length > 97 &&
                    <strong
                      style={{ fontSize: '12px', color: 'rgba(27, 27, 27, 1)', fontFamily: 'Inter-Bold', cursor: 'pointer' }}
                      onClick={() => setShowMore(!showMore)}>
                      {showMore ? ' ...menos' : ' ...mais'}
                    </strong>
                  }
                </Description>
              </DescriptionSection>
              <TranslateContainer>
                <ShowMore>Traduzir</ShowMore>
                <HideTagsContainer>
                  <ShowMore>{showTags ? 'Esconder tags' : 'Mostrar tags'}</ShowMore>
                  <motion.div
                    whileHover={{ scale: 1.5 }}
                    style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                    animate={{ rotate: showTags ? 0 : 180 }}
                    transition={{ duration: 0, ease: [0.04, 0.62, 0.23, 0.98] }}
                    onClick={() => handleExpandTags()}
                  >
                    <SmallArrowDown />
                  </motion.div>
                </HideTagsContainer>
              </TranslateContainer>
              <Collapsible style={{ overflow: 'scroll', maxHeight: 200 }} transitionTime={1} open={showTags} trigger={''}>
                <Tag>{tagsString}</Tag>
              </Collapsible>
              <HideTagsContainer style={{ marginTop: showTags ? 0 : -16 }} >
                <ShowMore>{commentsCount} comentários</ShowMore>
                <motion.div
                  whileHover={{ scale: 1.5 }}
                  style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                  animate={{ rotate: showComments ? 0 : 180 }}
                  transition={{ duration: 0, ease: [0.04, 0.62, 0.23, 0.98] }}
                  onClick={() => handleExpandComments()}
                >
                  <SmallArrowDown />
                </motion.div>
              </HideTagsContainer>
              <Collapsible
                open={showComments}
                trigger={''}
                transitionTime={1}
                style={{ height: '100%' }}
              >
                <CommentsContainer
                  ref={scrollRef}
                  style={{ overflow: scrollOverflow ? 'scroll' : 'hidden', maxHeight: 200 }}
                >
                  {commentsInfos && commentsInfos.map((comment, index) => (
                    <Comment
                      key={index}
                      index={index}
                      id={comment.id}
                      authorAvatarUrl={comment.authorAvatarUrl}
                      authorUsername={comment.authorUsername}
                      publicationUsername={authorUsername}
                      content={comment.content}
                      createdAt={comment.createdAt}
                      feedType={feedType}
                      childs={comment.childs}
                      parentId={comment.parentId}
                      likes={comment.likes}
                      publicationId={comment.publicationId}
                      updatedAt={comment.updatedAt}
                      authorId={comment.authorId}
                      handleResponse={handleComment}
                      setAnswerTarget={setAnswerTarget}
                      reloadSubComments={reloadSubComments}
                      setReloadSubComments={setReloadSubComments}
                      scrollPosition={scrollPosition}
                      setCommentModalIndex={setCommentModalId}
                      commentModalIndex={commentModalId}
                      setCommentModalOpen={setCommentModalOpen}
                      commentModalOpen={commentModalOpen}
                    />
                  ))}
                </CommentsContainer>
              </Collapsible>
            </InnerTopContainer>
            <InnerBottomContainer>
              <HorizontalIconsContainer>
                <IconsDupla onClick={handleLike}>
                  <LikeIcon liked={liked} />
                  {numberFormatter(likesCount)}
                </IconsDupla>
                <IconsDupla>
                  <CashIcon />
                  <div onClick={() => setShareModal(!shareModal)}>
                    <ShareIcon />
                  </div>
                </IconsDupla>
              </HorizontalIconsContainer>
              <CommentSection>
                <CommentPlaceholder
                  value={commmentValue}
                  onChange={(e) => handleComment(e.target.value)}
                  placeholder='Adicione um comentário'
                  onFocus={() => setCommentInputFocus(!commentInputFocus)}
                  onKeyUp={handleKeyDown}
                />
                <EmoteIcon />
              </CommentSection>
            </InnerBottomContainer>
          </Container>
          // </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence initial={false}>
        <ExpandContainer>
          <div
            style={{ opacity: open ? 0 : 1 }}
          >
            <ExpandContainerTop style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <Icon src={authorAvatarUrl} onClick={() => setPostModal(!postModal)} />
              <FollowText>Seguir</FollowText>
            </ExpandContainerTop>
          </div>
          <motion.div
            whileHover={{ scale: 1.5 }}
            animate={{ rotate: open ? 180 : 0 }}
            transition={{ duration: 0.7, ease: [0.04, 0.62, 0.23, 0.98] }}
            onClick={() => setOpen(!open)}
            style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            <ExpandArrow onClick={() => setOpen(!open)}>
              <ArrowRight />
            </ExpandArrow>
          </motion.div>
          <motion.div
            animate={{ opacity: open ? 0 : 1 }}
            transition={{ duration: 0.7, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            <ExpandContainerBottom>
              <ExpandIconContainer onClick={handleLike}>
                <LikeIcon liked={liked} />
                {numberFormatter(likesCount)}
              </ExpandIconContainer>
              <ExpandIconContainer onClick={() => setOpen(!open)}>
                <ChatIcon />
                {numberFormatter(commentsCount)}
              </ExpandIconContainer>
              <ExpandIconContainer onClick={() => setShareModal(!shareModal)}>
                <ShareIcon />
              </ExpandIconContainer>
              <ExpandIconContainer>
                <CashIcon />
              </ExpandIconContainer>
              <ExpandIconContainer onClick={() => setPostModal(!postModal)}>
                <DotsIcon />
              </ExpandIconContainer>
              <PostOptionsModal
                open={postModal}
                authorUsername={authorUsername}
                onAction={handleModalActions}
              />
              {shareModal && <SharePostModal
                authorUsername={authorUsername}
                id={publicationId}
                open={shareModal}
                onClose={setShareModal}
              />}
              {deleteModal && <DeleteModal
                onAction={handleModalActions}
              />}
            </ExpandContainerBottom>
          </motion.div>
        </ExpandContainer>
      </AnimatePresence>
    </MasterContainer>
  );
}

function ArrowRight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="15"
      fill="none"
      viewBox="0 0 9 15"
    >
      <path
        stroke="#4D4D4D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1.5 1.07l6 6-6 6"
      ></path>
    </svg>
  );
}

function DotsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="20"
      fill="none"
      viewBox="0 0 19 20"
    >
      <path
        fill="#4D4D4D"
        d="M9.5 10.545a.775.775 0 100-1.55.775.775 0 000 1.55zM9.5 5.12a.775.775 0 100-1.55.775.775 0 000 1.55zM9.5 15.97a.775.775 0 100-1.55.775.775 0 000 1.55z"
      ></path>
      <path
        stroke="#4D4D4D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M9.5 10.545a.775.775 0 100-1.55.775.775 0 000 1.55zM9.5 5.12a.775.775 0 100-1.55.775.775 0 000 1.55zM9.5 15.97a.775.775 0 100-1.55.775.775 0 000 1.55z"
      ></path>
    </svg>
  );
}

function CashIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      fill="none"
      viewBox="0 0 21 21"
    >
      <rect
        width="18.5"
        height="18.5"
        x="1.25"
        y="1.22"
        stroke="#4D4D4D"
        strokeWidth="1.5"
        rx="9.25"
      ></rect>
      <g
        stroke="#4D4D4D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.026"
        clipPath="url(#clip0_418_15666)"
      >
        <path d="M10.5 4.829V16.11M13.064 6.88H9.218a1.795 1.795 0 100 3.59h2.564a1.795 1.795 0 110 3.59h-4.36"></path>
      </g>
      <defs>
        <clipPath id="clip0_418_15666">
          <path
            fill="#fff"
            d="M0 0H12.308V12.308H0z"
            transform="translate(4.346 4.316)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}